// Mock data for Casa Cruz Landing Page

export const heroData = {
  title: "Precisão Técnica e Soluções em Engenharia",
  subtitle: "Engenharia de Ponta - Solu\xE7\xF5es t\xE9cnicas e sob medida para seu im\xF3vel.",
  ctaText: "Solicitar Orçamento"
};

export const servicesData = [
{
  id: 1,
  category: "Projetos de Engenharia",
  items: [
  { name: "Projetos Estruturais", icon: "Building2" },
  { name: "Projetos Arquitetônicos", icon: "Home" },
  { name: "Projetos Hidrossanitários", icon: "Droplets" },
  { name: "Projetos Elétricos", icon: "Zap" }]

},
{
  id: 2,
  category: "Perícias Técnicas e Laudos",
  items: [
  { name: "Avaliação de Imóveis", icon: "FileText" },
  { name: "Patologias em Edificações", icon: "AlertTriangle" },
  { name: "Vistoria Técnica", icon: "Search" },
  { name: "Laudos Judiciais", icon: "Scale" }]

}];


export const portfolioData = [
{
  id: 1,
  title: "Regularização e Legalização",
  description: "Aprovação e regularização de obras com documentação completa",
  image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=600&fit=crop",
  icon: "📐",
  backTitle: "REGULARIZAÇÃO\ne Legalização de Imóveis",
  backContent: [
  "Aprovação de Obra Nova para Emissão de Alvará de Construção",
  "Regularização de Obra Existente junto para Emissão de Habite-se",
  "Regularização na Receita Federal (CNO / INSS de obra)",
  "Averbações e retificações em Cartório"]

},
{
  id: 2,
  title: "Perícias Judiciais",
  description: "Laudos técnicos especializados para processos judiciais",
  image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&h=600&fit=crop",
  icon: "⚖️",
  backTitle: "PERÍCIAS JUDICIAIS",
  backContent: [
  "Perícia Judicial em Engenharia Civil",
  "Perícia Judicial em Engenharia e Segurança do Trabalho",
  "Assistência Técnica Judicial",
  "Laudos Técnicos para processos",
  "Pareceres Técnicos",
  "Esclarecimentos e impugnações técnicas"]

},
{
  id: 3,
  title: "Inspeção Predial",
  description: "Inspeções detalhadas em edificações e obras",
  image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=800&h=600&fit=crop",
  icon: "🏢",
  backTitle: "INSPEÇÃO PREDIAL",
  backContent: [
  "Inspeção Predial",
  "Laudo de Recebimento de Obra",
  "Vistoria de Vizinhança",
  "Plano de Manutenção Predial",
  "Manual do Proprietário e do Síndico"]

},
{
  id: 4,
  title: "Diagnóstico de Patologias",
  description: "Diagnóstico detalhado de problemas estruturais e patológicos",
  image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&h=600&fit=crop",
  icon: "🧱",
  backTitle: "DIAGNÓSTICO",
  backContent: [
  "Diagnóstico de patologias construtivas",
  "Laudos de infiltração, fissuras e falhas estruturais",
  "Investigação de causas de danos",
  "Planos de reparo e recuperação"]

},
{
  id: 5,
  title: "Avaliação de Imóveis",
  description: "Laudos técnicos precisos para avaliação de imóveis",
  image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop",
  icon: "💰",
  backTitle: "AVALIAÇÃO DE IMÓVEIS",
  backContent: [
  "Avaliação de Imóveis Urbanos para determinação de Valor de Mercado",
  "Avaliação Judicial",
  "Avaliação para garantias e inventários",
  "Avaliação com Inferência Estatística"]

},
{
  id: 6,
  title: "Projetos Diversos",
  description: "Projetos completos de engenharia e arquitetura",
  image: "https://images.unsplash.com/photo-1503387837-b154d5074bd2?w=800&h=600&fit=crop",
  icon: "🏗️",
  backTitle: "PROJETOS DIVERSOS\nEngenharia e Arquitetura",
  backContent: [
  "Projeto Arquitetônico",
  "Projeto Estrutural",
  "Projeto de Interiores",
  "Projeto Elétrico – Baixa Tensão",
  "Projeto Hidrossanitário",
  "AVCB - Projeto de Combate a incêndio"]

}];


export const differentialsData = [
{
  id: 1,
  title: "Rigor Normativo",
  description: "Todos os projetos seguem rigorosamente as normas técnicas brasileiras (NBR/ABNT)",
  icon: "Shield"
},
{
  id: 2,
  title: "Tecnologia Avançada",
  description: "Utilizamos softwares de última geração para análise e desenvolvimento de projetos",
  icon: "Cpu"
},
{
  id: 3,
  title: "Prazos Confiáveis",
  description: "Compromisso com prazos estabelecidos e entregas pontuais",
  icon: "Clock"
},
{
  id: 4,
  title: "Equipe Especializada",
  description: "Profissionais qualificados com registro no CREA e vasta experiência",
  icon: "Users"
}];


export const testimonialsData = [
{
  id: 1,
  name: "João Silva",
  role: "Proprietário",
  text: "Excelente trabalho! O laudo foi preciso e entregue no prazo. Recomendo!",
  rating: 5
},
{
  id: 2,
  name: "Maria Santos",
  role: "Construtora",
  text: "Profissionais extremamente competentes. Projetos de alta qualidade técnica.",
  rating: 5
},
{
  id: 3,
  name: "Carlos Oliveira",
  role: "Advogado",
  text: "Perícia técnica impecável para nosso processo judicial. Muito satisfeito!",
  rating: 5
}];


// Mock function to simulate form submission
export const mockContactSubmit = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock Contact Form Submission:", formData);
      resolve({ success: true, message: "Mensagem enviada com sucesso!" });
    }, 1000);
  });
};

// Mock function to simulate appointment scheduling
export const mockScheduleSubmit = (appointmentData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock Appointment Scheduling:", appointmentData);
      resolve({
        success: true,
        message: "Agendamento realizado com sucesso! Entraremos em contato em breve.",
        appointmentId: Math.random().toString(36).substr(2, 9)
      });
    }, 1000);
  });
};